import React, { useContext } from "react";
import "./css/common.css"
import { useTranslation } from 'react-i18next';
import { StateAmbContext } from '../../stateContext';

function FooterPrice(props) {
    const { settings } = useContext(StateAmbContext);

    const { t, i18n } = useTranslation();
    var noModels = props.noModels;
    if (props.tool === "System") {
        noModels = (props.CUnoModels || props.UCnoModels)
    }
    const handleBackClick = () => {
        localStorage.removeItem('area');
        localStorage.removeItem('rds');
        localStorage.setItem('a2lToggle', false)
        props.navigate("prev");
    };
    return (
        <div className="custom_container mb-3 p-0" >
            <div className="row" >
                <div className="col-sm-12 col-md-12 col-lg-6 totalam mb-2"> <h4 className="priceFontFooter">{t('foot_pricing.total')} - {props.tool === "System" ? "Condensing Unit(s) + Evaporator(s)" : (props.tool + "(s)")} : {(String(props.match.total_price_counts) === "0" || String(props.match.total_price_counts) === "NaN") ? "-" : "$" + (props.match.total_price_counts).toLocaleString()}</h4></div>
                <div className="col-sm-12 col-md-12 col-lg-6 row totalam ">
                    {settings.is_hub ? <div className="col-md-4 col-lg-4 pler1 bold"><div type="button" style={{ cursor: "pointer" }} className="col-sm-12 next-pre-btn" onClick={() => { try { window.HC.Selection.cancelToQuote() } catch (err) { var a = err; } }} >{t('common.Cancel')}</div> </div> : <></>}
                    <div className="col-md-4 col-lg-4 pler1 bold"><div type="button" style={{ cursor: "pointer" }} className="col-sm-12 next-pre-btn" onClick={handleBackClick} ><i className="fa  fa-angle-left"></i> {t('common.Back')}</div> </div>
                    <div style={noModels ? { pointerEvents: "none" } : {}} className="col-md-4 col-lg-4  pler2 bold"><div type="button" style={{ cursor: "pointer" }} className="col-sm-6 next-pre-btn" onClick={() => props.navigate("match")} >{t('foot_pricing.shw_results')}</div></div>
                </div>
            </div>
        </div>
    );
}

export default FooterPrice;


